/* ============================================
   ArquiConstruye — Three.js Particle Network
   Blueprint/wireframe aesthetic
   ============================================ */

(function () {
  'use strict';

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  function ready(cb) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', cb);
    } else {
      cb();
    }
  }

  function waitForThree(cb, n) {
    n = n || 0;
    if (window.THREE) { cb(); }
    else if (n < 200) { setTimeout(function () { waitForThree(cb, n + 1); }, 50); }
  }

  ready(function () {
    waitForThree(function () {
      var canvas = document.getElementById('arqThreeCanvas');
      if (!canvas) return;
      init(canvas);
    });
  });

  function init(canvas) {
    var section = canvas.closest('.arq-intro');
    if (!section) return;

    var width = section.offsetWidth;
    var height = section.offsetHeight;

    if (width === 0 || height === 0) return;

    var scene = new THREE.Scene();
    var camera = new THREE.PerspectiveCamera(60, width / height, 1, 1000);
    camera.position.z = isMobile ? 250 : 300;

    var renderer = new THREE.WebGLRenderer({
      canvas: canvas,
      alpha: true,
      antialias: true
    });
    renderer.setSize(width, height);
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));

    // Particles — scale to screen size
    var isMobile = width < 768;
    var count = isMobile ? 80 : Math.min(100, Math.floor(width / 15));
    var spreadX = isMobile ? 400 : 500;
    var spreadY = isMobile ? 300 : 300;
    var spreadZ = isMobile ? 100 : 150;
    var positions = new Float32Array(count * 3);
    var velocities = [];

    for (var i = 0; i < count; i++) {
      positions[i * 3]     = (Math.random() - 0.5) * spreadX;
      positions[i * 3 + 1] = (Math.random() - 0.5) * spreadY;
      positions[i * 3 + 2] = (Math.random() - 0.5) * spreadZ;
      velocities.push({
        x: (Math.random() - 0.5) * 0.25,
        y: (Math.random() - 0.5) * 0.25,
        z: (Math.random() - 0.5) * 0.1
      });
    }

    var geo = new THREE.BufferGeometry();
    geo.setAttribute('position', new THREE.BufferAttribute(positions, 3));

    var mat = new THREE.PointsMaterial({
      color: 0xA9A9A4,
      size: isMobile ? 4 : 3,
      transparent: true,
      opacity: 1,
      sizeAttenuation: true
    });

    scene.add(new THREE.Points(geo, mat));

    // Lines — pre-allocate for performance
    var maxLines = 300;
    var linePositions = new Float32Array(maxLines * 6);
    var lineGeo = new THREE.BufferGeometry();
    lineGeo.setAttribute('position', new THREE.BufferAttribute(linePositions, 3));
    lineGeo.setDrawRange(0, 0);

    var lineMat = new THREE.LineBasicMaterial({
      color: 0xA9A9A4,
      transparent: true,
      opacity: 0.2
    });
    var lines = new THREE.LineSegments(lineGeo, lineMat);
    scene.add(lines);

    // Mouse
    var mouse = { x: 0, y: 0 };
    var target = { x: 0, y: 0 };

    section.addEventListener('mousemove', function (e) {
      var rect = section.getBoundingClientRect();
      target.x = ((e.clientX - rect.left) / rect.width - 0.5) * 2;
      target.y = -((e.clientY - rect.top) / rect.height - 0.5) * 2;
    });

    var maxDist = isMobile ? 130 : 150;

    function animate() {
      requestAnimationFrame(animate);

      mouse.x += (target.x - mouse.x) * 0.04;
      mouse.y += (target.y - mouse.y) * 0.04;

      // Move particles
      var pos = geo.attributes.position.array;
      for (var i = 0; i < count; i++) {
        pos[i * 3]     += velocities[i].x;
        pos[i * 3 + 1] += velocities[i].y;
        pos[i * 3 + 2] += velocities[i].z;

        if (Math.abs(pos[i * 3])     > spreadX / 2) velocities[i].x *= -1;
        if (Math.abs(pos[i * 3 + 1]) > spreadY / 2) velocities[i].y *= -1;
        if (Math.abs(pos[i * 3 + 2]) > spreadZ / 2) velocities[i].z *= -1;
      }
      geo.attributes.position.needsUpdate = true;

      // Update connections
      var lp = lineGeo.attributes.position.array;
      var lineCount = 0;

      for (var a = 0; a < count && lineCount < maxLines; a++) {
        for (var b = a + 1; b < count && lineCount < maxLines; b++) {
          var dx = pos[a * 3] - pos[b * 3];
          var dy = pos[a * 3 + 1] - pos[b * 3 + 1];
          var dz = pos[a * 3 + 2] - pos[b * 3 + 2];
          var dist = dx * dx + dy * dy + dz * dz;

          if (dist < maxDist * maxDist) {
            var idx = lineCount * 6;
            lp[idx]     = pos[a * 3];
            lp[idx + 1] = pos[a * 3 + 1];
            lp[idx + 2] = pos[a * 3 + 2];
            lp[idx + 3] = pos[b * 3];
            lp[idx + 4] = pos[b * 3 + 1];
            lp[idx + 5] = pos[b * 3 + 2];
            lineCount++;
          }
        }
      }

      lineGeo.attributes.position.needsUpdate = true;
      lineGeo.setDrawRange(0, lineCount * 2);

      // Camera
      camera.position.x += (mouse.x * 35 - camera.position.x) * 0.02;
      camera.position.y += (mouse.y * 25 - camera.position.y) * 0.02;
      camera.lookAt(scene.position);

      renderer.render(scene, camera);
    }

    animate();

    // Resize
    var rt;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(function () {
        width = section.offsetWidth;
        height = section.offsetHeight;
        if (width && height) {
          camera.aspect = width / height;
          camera.updateProjectionMatrix();
          renderer.setSize(width, height);
        }
      }, 250);
    });
  }

  /* ============================================
     TOPOGRAPHIC TERRAIN — Final CTA section
     ============================================ */

  ready(function () {
    waitForThree(function () {
      var canvas = document.getElementById('arqTopoCanvas');
      if (!canvas) return;
      initTopo(canvas);
    });
  });

  function initTopo(canvas) {
    var section = canvas.closest('.arq-final');
    if (!section) return;

    var width = section.offsetWidth;
    var height = section.offsetHeight;
    if (!width || !height) return;

    var isMob = width < 768;
    var scene = new THREE.Scene();
    var camera = new THREE.PerspectiveCamera(45, width / height, 1, 1000);
    camera.position.set(0, isMob ? 80 : 120, isMob ? 140 : 200);
    camera.lookAt(0, 0, 0);

    var renderer = new THREE.WebGLRenderer({ canvas: canvas, alpha: true, antialias: true });
    renderer.setSize(width, height);
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));

    // Terrain grid
    var gridW = isMob ? 30 : 60;
    var gridH = isMob ? 20 : 40;
    var spacing = isMob ? 10 : 8;
    var vertices = [];

    for (var z = 0; z < gridH; z++) {
      for (var x = 0; x < gridW; x++) {
        var px = (x - gridW / 2) * spacing;
        var pz = (z - gridH / 2) * spacing;
        var py = 0; // will animate
        vertices.push(px, py, pz);
      }
    }

    // Create line segments for contour lines (horizontal rows)
    var lineMat = new THREE.LineBasicMaterial({
      color: 0xA9A9A4,
      transparent: true,
      opacity: 0.35
    });

    var lines = [];
    for (var z = 0; z < gridH; z++) {
      var positions = new Float32Array(gridW * 3);
      for (var x = 0; x < gridW; x++) {
        var idx = (z * gridW + x) * 3;
        positions[x * 3] = vertices[idx];
        positions[x * 3 + 1] = vertices[idx + 1];
        positions[x * 3 + 2] = vertices[idx + 2];
      }
      var geo = new THREE.BufferGeometry();
      geo.setAttribute('position', new THREE.BufferAttribute(positions, 3));
      var line = new THREE.Line(geo, lineMat);
      scene.add(line);
      lines.push({ geo: geo, row: z });
    }

    // Also add vertical lines (less visible)
    var vertMat = new THREE.LineBasicMaterial({
      color: 0xA9A9A4,
      transparent: true,
      opacity: 0.1
    });

    for (var x = 0; x < gridW; x += 3) {
      var positions = new Float32Array(gridH * 3);
      for (var z = 0; z < gridH; z++) {
        var idx = (z * gridW + x) * 3;
        positions[z * 3] = vertices[idx];
        positions[z * 3 + 1] = vertices[idx + 1];
        positions[z * 3 + 2] = vertices[idx + 2];
      }
      var geo = new THREE.BufferGeometry();
      geo.setAttribute('position', new THREE.BufferAttribute(positions, 3));
      scene.add(new THREE.Line(geo, vertMat));
    }

    // Mouse
    var mouse = { x: 0, y: 0 };
    var target = { x: 0, y: 0 };

    section.addEventListener('mousemove', function (e) {
      var rect = section.getBoundingClientRect();
      target.x = ((e.clientX - rect.left) / rect.width - 0.5) * 2;
      target.y = -((e.clientY - rect.top) / rect.height - 0.5) * 2;
    });

    var time = 0;

    function animate() {
      requestAnimationFrame(animate);
      time += 0.008;

      mouse.x += (target.x - mouse.x) * 0.03;
      mouse.y += (target.y - mouse.y) * 0.03;

      // Update terrain height — wave function
      for (var z = 0; z < gridH; z++) {
        var geo = lines[z].geo;
        var pos = geo.attributes.position.array;

        for (var x = 0; x < gridW; x++) {
          var px = (x - gridW / 2) * spacing;
          var pz = (z - gridH / 2) * spacing;

          // Multiple sine waves for organic terrain
          var h = Math.sin(px * 0.02 + time) * 12 +
                  Math.sin(pz * 0.03 + time * 0.7) * 8 +
                  Math.sin((px + pz) * 0.015 + time * 1.3) * 6 +
                  Math.cos(px * 0.04 - time * 0.5) * 4;

          // Mouse influence — pushes terrain up near cursor
          var mx = mouse.x * (gridW / 2) * spacing;
          var my = mouse.y * (gridH / 2) * spacing;
          var dist = Math.sqrt((px - mx) * (px - mx) + (pz - my) * (pz - my));
          if (dist < 80) {
            h += (80 - dist) * 0.3;
          }

          pos[x * 3 + 1] = h;
        }

        geo.attributes.position.needsUpdate = true;
      }

      // Camera subtle movement
      camera.position.x = mouse.x * 30;
      camera.position.z = 200 + mouse.y * 20;
      camera.lookAt(0, 0, 0);

      renderer.render(scene, camera);
    }

    animate();

    // Resize
    var rt;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(function () {
        width = section.offsetWidth;
        height = section.offsetHeight;
        if (width && height) {
          camera.aspect = width / height;
          camera.updateProjectionMatrix();
          renderer.setSize(width, height);
        }
      }, 250);
    });
  }
})();
